import React from "react";
import { trb } from "@utilities";

export const KycComplete = React.memo((props) => {
  return (
    <div className="row col-12 align-items-center">
      <div className="col-12 col-md-5 mb-5">
        <img
          src="/images/slider/onboarding_complete.png"
          className="w-100"
          alt="onboarding complete logo"
        />
      </div>
      <div className="col-12 col-md-6 offset-md-1 eb_fs_18 eb_fw_300 p-5">
        {trb(props.translation)}{" "}
        <a
          href="https://smebank.lt/paskolos/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
        >
          {trb(props.linkTranslation)}
        </a>
      </div>
    </div>
  );
});
